/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_LabelAndReferenceGet } from '../models/Model_LabelAndReferenceGet';
import type { Model_LabelAndReferencePost } from '../models/Model_LabelAndReferencePost';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProjectLabelService {
    /**
     * @param projectId
     * @returns Model_LabelAndReferenceGet Success
     * @throws ApiError
     */
    public static getApiV1LabelProject(
        projectId: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_LabelAndReferenceGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/label/project/{projectId}',
            path: {
                'projectId': projectId,
            },
        });
    }
    /**
     * @param projectId
     * @param requestBody
     * @returns Model_LabelAndReferenceGet Success
     * @throws ApiError
     */
    public static postApiV1LabelProject(
        projectId: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_LabelAndReferencePost>,
    ): CancelablePromise<Array<Model_LabelAndReferenceGet>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/label/project/{projectId}',
            path: {
                'projectId': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
